<template>
  <div id="enderecos">
    <div v-for="item in enderecos" :key="item[0]._id" id="enderecos_lista">
      <div v-for="item_ in item" :key="item_._id" id="enderecos_coluna">
        <Endereco :item="item_" :updateItems="updateItems" />
      </div>
    </div>
  </div>
</template>

<script>
import Endereco from "./Endereco";
export default {
  name: "Enderecos",
  props: {
    enderecos: {type: Array},
    updateArray: {type: Function}
  },
  components: {
    Endereco
  },
  methods: {
    updateItems(){
      if(this.updateArray){
        this.updateArray();
      }
      this.$forceUpdate();
    }
  }
};
</script>

<style>
#enderecos {
  margin: 0 auto;
  margin-left: 20px;
  margin-right: 20px;
}

#enderecos_lista {
  display: flex;
  margin-top: 10px;
}

#enderecos_coluna {
}
</style>
